import script from "./TelegramNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./TelegramNotifications.vue?vue&type=script&setup=true&lang=js"

import "./TelegramNotifications.vue?vue&type=style&index=0&id=5109ccd5&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5109ccd5"]])

export default __exports__